// ACTION TYPES //
export const SET_SESSION = 'set_session';
export const SET_SESSION_PROMISE = 'set_session_promise';

// ACTION CREATORS //
export function setSessionData(token) {
  return ({
    type: SET_SESSION,
    payload: token,
  });
}

export function setSessionPromise(promise) {
  return ({
    type: SET_SESSION_PROMISE,
    payload: promise,
  });
}

// REDUCERS //
/* A reducer to populate session information such as the access token
 * expire time.
 */
// A reducer to track whether session information is
// in the process being refreshed
export const sessionPromiseReducer = (state = null, action) =>  {
  switch (action.type) {
    case SET_SESSION_PROMISE:
      return action.payload;
    default:
      return state;
  }
}

export default function sessionReducer(state = { accessTokenExpireTime: null }, action) {
  switch (action.type) {
    case SET_SESSION:
      return action.payload;
    default:
      return state;
  }
}
